import i18n from "i18next"
import { initReactI18next } from "react-i18next"
import enJSON from "./en.json"
import ptJSON from "./pt.json"
import { LanguageService } from "services/languageService"

// Get saved language or default to English
const savedLanguage = LanguageService.getSavedLanguage() || "en"

i18n.use(initReactI18next).init({
  resources: {
    en: enJSON,
    pt: ptJSON,
  },
  lng: savedLanguage,
  fallbackLng: "en",
  interpolation: {
    escapeValue: false,
  },
})
